import { render, staticRenderFns } from "./ApplicantSuggestedPosition.vue?vue&type=template&id=44dd39ee&scoped=true"
import script from "./ApplicantSuggestedPosition.vue?vue&type=script&lang=js"
export * from "./ApplicantSuggestedPosition.vue?vue&type=script&lang=js"
import style0 from "./ApplicantSuggestedPosition.vue?vue&type=style&index=0&id=44dd39ee&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44dd39ee",
  null
  
)

export default component.exports